import {Injectable} from '@angular/core';

import {ParametreSocieteModel} from '../../../models/app/parametres/parametreSociete.model';
import {Observable} from 'rxjs';
import {ParametreCollaborateurModel} from '../../../models/app/parametres/parametreCollaborateur.model';
import {AppService} from '../app.service';

@Injectable(
    {
        providedIn: 'root' // il permet d'ajouter ce service dans les providers 'global' de l'app
    }
)
export class ParametresService extends AppService {

    ////////////////// PARAMS SOCIETE ////////////////////////

    // save to server
    saveParamSocieteOnServer(): Observable<any> {
        let parametresSociete = localStorage.getItem('parametresSociete');
        return this.httpPatch('societe/parametres', parametresSociete)
    }


    // get fromserver
    getParamSocieteFromServer() {
		let parametresSociete = new ParametreSocieteModel();
        this.httpPost('societe/parametres/get', parametresSociete).subscribe(
            (data: any) => {
                if (data == null || data.toString()=='') {
                    data = new ParametreSocieteModel();
                }
                if (data) {
                    localStorage.setItem('parametresSociete', JSON.stringify(data));
                }
            }
        );
    }

////////////////// PARAMS COLLABORATEUR ////////////////////////

    // save to server
    saveParamCollaborateurOnServer(): Observable<any> {
        let parametresCollaborateur = localStorage.getItem('parametresCollaborateur');
        return this.httpPatch('collaborateur/parametres', {parametres:parametresCollaborateur})
    }


    // get fromserver
    getParamCollaborateurFromServer() {
		let parametresCollaborateur = new ParametreCollaborateurModel();
        this.httpPost('collaborateur/parametres/get', parametresCollaborateur).subscribe(
            (data: any) => {
                if (data == null || data.toString()=='') {
                    data = new ParametreCollaborateurModel();
                }
                if (data) {
                    localStorage.setItem('parametresCollaborateur', JSON.stringify(data));
                }
            }
        );
    }
}
